import { IconButton } from "@mui/material";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";
import { PageHeaderContext } from "@ryde/redux";

import { useTableFiltersActionsReports } from "./use-table-filters-actions-reports";

export const FilterClearButtonReports = (): ReactElement => {
  const { t } = useTranslation();
  const { handleClearFilters } = useTableFiltersActionsReports();
  const { onFiltersClear } = useContext(PageHeaderContext);

  const handleOnClick = async (): Promise<void> => {
    await handleClearFilters();
    onFiltersClear?.();
  };

  return (
    <IconButton
      data-e2e="clear_filters_button"
      title={t(`general.CLEAR_ALL_FILTERS`)}
      onClick={handleOnClick}
    >
      <PIC.FilterClearSvg />
    </IconButton>
  );
};
